import * as React from 'react';
import { getOwaCommonStrings } from 'owa-strings/owa-common-strings';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';

const styles = require('./LoadingView.scss');

export function LoadingView() {
    return (
        <div className={styles.container}>
            <Spinner size={SpinnerSize.medium} />
            <div className={styles.text}>{getOwaCommonStrings().loadingText}</div>
        </div>
    );
}
